module.exports = __webpack_public_path__ + "icon-arrows.png?733a2b0491a64dd18cef3b193522a2b4";


//////////////////
// WEBPACK FOOTER
// ./static/icon-arrows.png
// module id = 17
// module chunks = 0